// extracted by mini-css-extract-plugin
module.exports = {"CloseBtn":"_1uHkw-5bsw5szadu4vCrW7"};